import { Action } from '@ngrx/store';
import { Alternate } from '@boels/models';

export const LOAD_ALTERNATES = '[BoelsAlternates] Load Alternates';
export const LOAD_ALTERNATES_SUCCESS =
  '[BoelsAlternates] Load Alternates Success';
export const LOAD_ALTERNATES_FAIL = '[BoelsAlternates] Load Alternates Fail';

export class LoadAlternates implements Action {
  readonly type = LOAD_ALTERNATES;

  constructor(public payload: { categoryId: string }) {}
}

export class LoadAlternatesSuccess implements Action {
  readonly type = LOAD_ALTERNATES_SUCCESS;
  constructor(
    public payload: {
      categoryCode: string;
      alternates: Alternate[];
    },
  ) {}
}

export class LoadAlternatesFail implements Action {
  readonly type = LOAD_ALTERNATES_FAIL;
  constructor(public payload: any) {}
}

export type BoelsAlternatesAction =
  | LoadAlternates
  | LoadAlternatesSuccess
  | LoadAlternatesFail;
